import { ViewsApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export interface MachineStatusViewAddInterface {
  id: string;
  melcoMachineStatisticsModelsUpdateGroup: {
    name: string;
    machine_list: [];
    grouped_display: boolean;
  };
}

export const useMachineStatusViewAdd = () => {
  const [MachineStatusViewAdd] = useAPIAction(
    ViewsApi,
    async (api: ViewsApi, MachineStatusViewAddDetails: any) => {
      const { id, name, group_list, grouped_display } =
        MachineStatusViewAddDetails;

      let data = await api.statisticalViewCreate({
        reportingMelcoMachineStatisticsModelsCreateView: {
          name: name,
          group_list: group_list,
          grouped_display: grouped_display,
        },
      });

      return {
        data,
        successMessages: [{ message: "default" }],
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "reporting.machinestatus.view.actions.add",
    }
  );

  return useCallback(
    async (MachineStatusViewAddDetails: any) => {
      return await MachineStatusViewAdd(MachineStatusViewAddDetails);
    },
    [MachineStatusViewAdd]
  );
};
